import { render, staticRenderFns } from "./PreviewOriginalModel.vue?vue&type=template&id=1a9ae8c0"
import script from "./PreviewOriginalModel.vue?vue&type=script&lang=js"
export * from "./PreviewOriginalModel.vue?vue&type=script&lang=js"
import style0 from "./PreviewOriginalModel.vue?vue&type=style&index=0&id=1a9ae8c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports